function openTab(evt, tabId) {
  var i, tabcontent, tablinks;

  // Hide all tab content and show the clicked tab content
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(
      " activeContent",
      ""
    );
  }
  document.getElementById(tabId).className += " activeContent";

  // Change the active tab button
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  evt.currentTarget.className += " active";
}

document.addEventListener("DOMContentLoaded", function () {
  // Get all the tab buttons
  const tabButtons = document.querySelectorAll(".tablinks");

  // Add event listeners to all the tab buttons
  tabButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      openTab(event, button.getAttribute("tab-target"));
    });
  });
});
